<div class="modal-header">
  <h4 class="modal-title">Nro. de comprobante: {{ comprobante.Numero }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="formComprobante" class="theme-form" autocomplete="off">
    <div class="row pb-2">
      <label class="col-sm-2"> Número </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="Numero"
          readonly
        />
      </div>
      <label class="col-sm-2"> Fecha </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="Fecha"
          readonly
        />
      </div>
    </div>
    <div class="row pb-2">
      <label class="col-sm-2"> Forma de pago </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="FormaPago"
          readonly
        />
      </div>
      <label class="col-sm-2"> Tipo Comprobante </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="TipoComp"
          readonly
        />
      </div>
    </div>
    <div class="row pb-2">
      <label class="col-sm-2"> Sucursal </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="Sucursal"
          readonly
        />
      </div>
      <label class="col-sm-2"> Depósito </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="Deposito"
          readonly
        />
      </div>
    </div>
    <div class="row pb-2" *ngIf="!mostrarComponente(true)">
      <label class="col-sm-2"> Fecha y Hora Entrega </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="FechaEntrega"
          readonly
        />
      </div>
      <label class="col-sm-2"> Dirección Entrega </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          type="text"
          formControlName="DireccionEntrega"
          readonly
        />
      </div>
    </div>
    <div class="row pb-2">
      <label class="col-sm-2"> Observación </label>
      <div class="col-sm-10">
        <textarea
          class="form-control"
          rows="2"
          formControlName="Observacion"
          readonly
        ></textarea>
      </div>
    </div>
    <div class="row p-3">
      <div class="col-sm-12"></div>
    </div>
    <div class="row pb-3" *ngIf="comprobante.Articulos.length !== 0">
      <div class="col-sm-12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Nombre</th>
              <th scope="col" class="text-right">Cantidad</th>
              <th scope="col" class="text-right" *ngIf="!ocultarPreciosUnit">
                Precio Neto
              </th>
              <th scope="col" class="text-right" *ngIf="!ocultarPreciosUnit">
                % Descuento
              </th>
              <th scope="col" class="text-right" *ngIf="!ocultarPreciosUnit">
                Total Neto
              </th>
              <th scope="col" class="text-right">Total Final</th>
            </tr>
          </thead>
          <tbody>
            <!--Recorre el modelo detalles-->
            <tr *ngFor="let art of comprobante.Articulos">
              <th scope="row">{{ art.Codigo }}</th>
              <td>{{ art.Descripcion }}</td>
              <td class="text-right">
                {{ art.Cantidad | currency : "" : "" : ".2-2" : "es" }}
              </td>
              <td class="text-right" *ngIf="!ocultarPreciosUnit">
                {{ simboloMoneda
                }}{{ art.PrecioNeto | currency : "" : "" : ".2-2" : "es" }}
              </td>
              <td class="text-right" *ngIf="!ocultarPreciosUnit">
                {{ art.PjeDescuento | currency : "" : "" : ".2-2" : "es" }} %
              </td>
              <td class="text-right" *ngIf="!ocultarPreciosUnit">
                {{ simboloMoneda
                }}{{ art.TotalNeto | currency : "" : "" : ".2-2" : "es" }}
              </td>
              <td class="text-right">
                {{ simboloMoneda
                }}{{ art.TotalFinal | currency : "" : "" : ".2-2" : "es" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="collapsible" [@collapse]="masInfo">
      <div class="row pb-2" *ngIf="mostrarComponente(false)">
        <div class="col-sm-6"></div>
        <label
          class="col-sm-2"
          (click)="toggleMasDatos(0)"
          style="cursor: pointer"
        >
          Subtotal Neto
          <i [class]="!masDatos ? 'fa fa-minus' : 'fa fa-plus'"></i>
        </label>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text secondary-color">{{
                simboloMoneda
              }}</span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="SubtotalNeto"
              readonly
              style="text-align: right"
            />
          </div>
        </div>
      </div>

      <div class="row pb-2" *ngIf="!mostrarComponente(false)">
        <div class="col-sm-6"></div>
        <label
          class="col-sm-2"
          (click)="toggleMasDatos(0)"
          style="cursor: pointer"
        >
          Subtotal Final
        </label>
        <div class="col-sm-4">
          <input
            class="form-control"
            type="text"
            formControlName="SubtotalFinal"
            readonly
            style="text-align: right"
          />
        </div>
      </div>
      <div class="row pb-2 collapsible" [@collapse]="masDatos">
        <label class="col-sm-2 vertical-center"> Total Gravado </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="TotalGravado"
            readonly
            style="text-align: right"
          />
        </div>
        <label class="col-sm-2"> Total No Gravado </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="TotalNoGravado"
            readonly
            style="text-align: right"
          />
        </div>
        <label class="col-sm-2"> Exento </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="Exento"
            readonly
            style="text-align: right"
          />
        </div>
      </div>
      <div class="row pb-2">
        <div class="col-sm-6"></div>
        <label class="col-sm-2">
          Descuento ({{ pjeDescuento | currency : "" : "" : ".2-2" : "es" }} %)
        </label>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text secondary-color">{{
                simboloMoneda
              }}</span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="Descuento"
              readonly
              style="text-align: right"
            />
          </div>
        </div>
      </div>
      <div class="row pb-2" *ngIf="mostrarComponente(false)">
        <div class="col-sm-6"></div>
        <label
          class="col-sm-2"
          (click)="toggleMasIva(0)"
          style="cursor: pointer"
        >
          Total IVA <i [class]="!masIva ? 'fa fa-minus' : 'fa fa-plus'"></i>
        </label>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text secondary-color">{{
                simboloMoneda
              }}</span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="TotalIva"
              readonly
              style="text-align: right"
            />
          </div>
        </div>
      </div>
      <div class="collapsible" [@collapse]="masIva">
        <ng-container *ngFor="let montoGrav of comprobante.MontoGravado">
          <div class="row pb-2">
            <label class="col-sm-2"> Pje. Iva </label>
            <div class="col-sm-2">
              <input
                class="form-control"
                type="text"
                readonly
                style="text-align: right"
                [value]="montoGrav.PjeIva | currency : '' : '' : '.2-2' : 'es'"
              />
            </div>
            <label class="col-sm-2"> Gravado </label>
            <div class="col-sm-2">
              <input
                class="form-control"
                type="text"
                readonly
                style="text-align: right"
                [value]="montoGrav.Gravado | currency : '' : '' : '.2-2' : 'es'"
              />
            </div>
            <label class="col-sm-2"> Monto Iva </label>
            <div class="col-sm-2">
              <input
                class="form-control"
                type="text"
                readonly
                style="text-align: right"
                [value]="
                  montoGrav.MontoIva | currency : '' : '' : '.2-2' : 'es'
                "
              />
            </div>
          </div>
        </ng-container>
      </div>
      <div class="row pb-2" *ngIf="mostrarComponente(false)">
        <div class="col-sm-6"></div>
        <label
          class="col-sm-2"
          (click)="toggleTributos(0)"
          style="cursor: pointer"
        >
          Otros tributos
          <i [class]="!masTributos ? 'fa fa-minus' : 'fa fa-plus'"></i>
        </label>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text secondary-color">{{
                simboloMoneda
              }}</span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="Tributos"
              readonly
              style="text-align: right"
            />
          </div>
        </div>
      </div>
      <div class="row pb-2 collapsible" [@collapse]="masTributos">
        <label class="col-sm-2"> Imp.Interno </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="ImpInterno"
            readonly
            style="text-align: right"
          />
        </div>
        <label class="col-sm-2"> Perc. IVA </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="PercIva"
            readonly
            style="text-align: right"
          />
        </div>
        <label class="col-sm-2"> Perc. IIBB </label>
        <div class="col-sm-2">
          <input
            class="form-control"
            type="text"
            formControlName="PercIibb"
            readonly
            style="text-align: right"
          />
        </div>
      </div>
    </div>

    <div class="row pb-2">
      <div class="col-sm-6">
        <p-button
          [icon]="!masInfo ? 'pi pi-minus' : 'pi pi-plus'"
          (click)="toggleMasInfo(0)"
          styleClass="p-button-text"
          label="información"
        ></p-button>
      </div>
      <label class="col-sm-2 font-weight-bold"> Total </label>
      <div class="col-sm-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text secondary-color">{{
              simboloMoneda
            }}</span>
          </div>
          <input
            class="form-control font-weight-bold"
            type="text"
            formControlName="Importe"
            readonly
            style="text-align: right"
          />
        </div>
      </div>
    </div>
    <div class="row pb-2 flex-row-reverse pr-2" style="color: #808080">
      * Todos los valores se visualizan en {{ comprobante.Moneda.Nombre }}
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cerrar
  </button>
</div>
